// ── PWA INSTALL ───────────────────────────────
export let pwaPrompt = null;

// Afregistrer service worker og ryd cache
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
  caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
export function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
}

// Fang Android/Chrome install prompt
window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault();
  pwaPrompt = e;
  showInstallBtn();
});

export function showInstallBtn() {
  if (isInStandaloneMode()) return;
  const btn = document.getElementById('bni-install');
  if (btn && (pwaPrompt || isIos())) btn.style.display = 'flex';
}

export function showPwaBannerIfLoggedIn() {
  showInstallBtn();
}

export async function triggerInstall() {
  if (pwaPrompt) {
    // Android/Chrome — native prompt
    pwaPrompt.prompt();
    const { outcome } = await pwaPrompt.userChoice;
    if (outcome === 'accepted') {
      document.getElementById('bni-install').style.display = 'none';
      pwaPrompt = null;
    }
  } else if (isIos()) {
    // iOS — vis modal med vejledning
    document.getElementById('ios-install-modal').classList.add('open');
  }
}
